/**
 * Shared UI messages used across components.
 * Polish translations are maintained in pl.json.
 */
import labels from './pl.json';

export const SHARED_MESSAGES = {
  DOWNLOAD_STARTED: labels.DOWNLOAD_STARTED.pl,
  DOWNLOAD_READY_MESSAGE: labels.DOWNLOAD_READY_MESSAGE.pl,
  DROPDOWN_NO_RESULTS: labels.DROPDOWN_NO_RESULTS.pl,
} as const;
